import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
var InventoryHttpService = /** @class */ (function () {
    function InventoryHttpService(http, configService) {
        this.http = http;
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    InventoryHttpService.prototype.getMachineInventory = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_mac_inventory';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                //   console.log(response);
                observer.next(response.data || response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    InventoryHttpService.prototype.getMachineLocInventory = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_mac_loc_inventory';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                //   console.log(response);
                observer.next(response.data || response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    InventoryHttpService.prototype.getCampusInventory = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get_campus_inventory';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                //   console.log(response);
                observer.next(response.data || response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    InventoryHttpService.prototype.updateMacInv = function (queryParams) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var path = '/dashboard/update_mac_inventory';
            var params = {
                body: queryParams
            };
            API.put(_this.apiName, path, params).then(function (resp) {
                resolve(resp.data);
            }).catch(function (err) {
                console.log(err.response);
                reject(err);
            });
        });
    };
    InventoryHttpService.prototype.updateMacLocInv = function (queryParams) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var path = '/dashboard/update_mac_loc_inventory';
            var params = {
                body: queryParams
            };
            API.put(_this.apiName, path, params).then(function (resp) {
                resolve(resp.data);
            }).catch(function (err) {
                console.log(err.response);
                reject(err);
            });
        });
    };
    InventoryHttpService.prototype.updateCampusInventory = function (queryParams) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var path = '/dashboard/update_campus_inventory';
            var params = {
                body: queryParams
            };
            API.put(_this.apiName, path, params).then(function (resp) {
                resolve(resp.data);
            }).catch(function (err) {
                console.log(err.response);
                reject(err);
            });
        });
    };
    InventoryHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InventoryHttpService_Factory() { return new InventoryHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: InventoryHttpService, providedIn: "root" });
    return InventoryHttpService;
}());
export { InventoryHttpService };
